const connection = io.connect(`${location.protocol}//${location.hostname}:4001/`);

module.exports = {
	connection
}
